import { format, parse } from 'date-fns'
import isEmpty from 'lodash/isEmpty'

export default function useUtils() {
  const formatProductPreorderDate = (date?: string | null) => {
    if (!date) { return '' }
    return format(parse(date, 'yyyy-MM-dd', new Date()), 'MM.yyyy')
  }

  const getParsedAdditionalFields = (
    additionalFields: Record<string, any>,
    additionalFieldsForm: Record<string, any>,
  ) => {
    if (isEmpty(additionalFields)) {
      return {}
    }

    const sortObjectByNames = (obj: Record<string, any>) => {
      return Object.entries(obj)
        .sort((a, b) => {
          const aName = (a[1]?.name || a[0]).toString()
          const bName = (b[1]?.name || b[0]).toString()
          return aName.localeCompare(bName)
        })
        .reduce((acc: Record<string, any>, [key, value]) => {
          acc[key] = value
          return acc
        }, {})
    }

    if (!isEmpty(additionalFieldsForm)) {
      const parsedFields: Record<string, any> = {
        ...additionalFields,
      }
      for (let key in parsedFields) {
        const options = additionalFieldsForm[key]?.options
        const matchingOption = options?.find((option) => option.value === parsedFields[key]?.value)
        if (matchingOption) {
          parsedFields[key]!.value = matchingOption.text
        }
      }
      return sortObjectByNames(parsedFields)
    }
    return sortObjectByNames(additionalFields)
  }

  return { formatProductPreorderDate, getParsedAdditionalFields }
}
